package gay.spiders.util

import com.varabyte.kobweb.core.AppGlobals

fun imageResource(path: String): String {
    val isProd = AppGlobals["isProd"]?.toBoolean() ?: false
    return if (isProd) "/resources$path" else path
}